<template>
  <path
    d="M17.7 15.8902L13.82 12.0002L17.71 8.11024C18.1 7.72024 18.1 7.09024 17.71 6.70024C17.32 6.31024 16.69 6.31024 16.3 6.70024L11.71 11.2902C11.32 11.6802 11.32 12.3102 11.71 12.7002L16.3 17.2902C16.69 17.6802 17.32 17.6802 17.71 17.2902C18.09 16.9102 18.09 16.2702 17.7 15.8902ZM7 6.00024C7.55 6.00024 8 6.45024 8 7.00024V17.0002C8 17.5502 7.55 18.0002 7 18.0002C6.45 18.0002 6 17.5502 6 17.0002V7.00024C6 6.45024 6.45 6.00024 7 6.00024Z"
  />
</template>
